import Statistic from "./Statistic";
import request from "../../../request";
import { capitalize } from "@mui/material";

export default function Loans() {

   return <Statistic
      title="Loans"
      variant="bar"
      fetchData={async (from, to) => {

         const res = await request.get('/api/general/reports/loans', { params: { from, to } });
         const { count, revenue } = res.data;

         const statusCards = [];

         for (const status in count.status) {

            if (status === "overall")
               continue;

            statusCards.push({
               title: capitalize(status),
               number: count.status[status]
            });
         }

         const productTypeCards = [];

         for (const productType in count.product_type) {
            
            if (productType === "overall")
               continue;

            productTypeCards.push({
               title: capitalize(productType),
               number: count.product_type[productType]
            });
         }

         const revenueCards = [];

         for (const item of revenue) {
            revenueCards.push({
               title: capitalize(item.product_type),
               number: {
                  Expected: item.expected || 0,
                  Collected: item.collected || 0
               }
            });
         }

         const tabs = [
            {
               label: "Status",
               cards: statusCards
            },
            {
               label: "Product Type",
               cards: productTypeCards
            },
            {
               label: "Revenue",
               cards: revenueCards
            },
         ];

         return tabs;
      }}
   />
}